import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerListComponent } from '@client/customer/customer-list/customer-list.component';
import { CustomerShowComponent } from '@client/customer/customer-show/customer-show.component';
// import { ContractTemplateEditorComponent } from './contract-template-editor/contract-template-editor/contract-template-editor.component';
// import { ContractTemplateListComponent } from './contract-template-list/contract-template-list/contract-template-list.component';


const routes: Routes = [
  { path: "", component: CustomerListComponent },
  { path: "show/:id",  component: CustomerShowComponent },
  // {
  //   path: 'contract-templates',
  //   children: [
  //     {
  //       path: '',
  //       component: ContractTemplateListComponent, // Liste des templates
  //     },
  //     {
  //       path: 'new',
  //       component: ContractTemplateEditorComponent, // Créer un nouveau template
  //     },
  //     {
  //       path: 'edit/:id',
  //       component: ContractTemplateEditorComponent, // Éditer un template existant
  //     }
  //   ]
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientRoutingModule { }
